import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

interface LanguageSwitcherProps {
    collapsed?: boolean;
    onLanguageChange?: (lang: string) => void;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ collapsed, onLanguageChange }) => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'el' : 'en';
        i18n.changeLanguage(newLang);
        if (onLanguageChange) {
            onLanguageChange(newLang);
        }
    };

    return (
        <button
            onClick={toggleLanguage}
            className={`
                flex items-center gap-3 w-full p-3 rounded-xl transition-all
                ${collapsed ? 'justify-center' : 'justify-start'}
                text-slate-500 hover:bg-slate-50 hover:text-slate-900
            `}
            title="Switch Language"
        >
            <Globe size={20} strokeWidth={1.5} />
            {!collapsed && (
                <div className="flex items-center justify-between flex-1">
                    <span className="text-sm font-medium">
                        {i18n.language === 'en' ? 'English' : 'Ελληνικά'}
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-slate-100 font-bold uppercase text-slate-400">
                        {i18n.language === 'en' ? 'EN' : 'EL'}
                    </span>
                </div>
            )}
        </button>
    );
};
